import { useTranslation } from "next-i18next";

import { ProductBySlugNonNullable } from "@/common/contracts/pdp.contracts";
import { Body } from "@whoppah/ui/typography/Body";

type ProductDetailsInfoNewPriceProps = {
  product: ProductBySlugNonNullable;
};

export const ProductDetailsInfoNewPrice = ({
  product,
}: ProductDetailsInfoNewPriceProps) => {
  const { t } = useTranslation();

  const newPrice = product.newPrice;

  if (!newPrice) {
    return null;
  }

  return (
    <Body as="span" className="text-brand-500">
      {t("pdp:pdp-item-new-price", {
        price: newPrice,
      })}
    </Body>
  );
};
